import { ChartHeader } from "components/dataVisualization/chartComponents/style";
import styled from "styled-components";

export const RightAlignedChartHeader = styled(ChartHeader)`
  justify-content: end;
`;
